export default "__VITE_ASSET__3706533f__"